<template>
    <b-container class="modal-container">
        <div class="x-container" @click="hideModal">
            <img class="x-img" src="@/assets/x.svg" />
        </div>
        <b-row class="first-row">
            <!-- <b-col>
                <div class="pdf-container">
                    <iframe :src="bollaUrl" type="application/pdf" width="100%" height="600px" style="overflow: auto;">
                    </iframe>
                </div>
            </b-col>
            <b-col>
                <h1 class="title-item"> {{bolla.nome}} </h1>
                <hr>
                <p class="body-item"><small>Data bolla:</small> {{format_date(bolla.data_bolla)}}</p>
                <p class="body-item"><small>Nome del dottore:</small> {{dottore.nome + ' ' + dottore.cognome}}</p>
                <p class="body-item"><small>Nome del paziente:</small> {{paziente.nome + ' ' + paziente.cognome}}</p>
            </b-col> -->
            <b-col>
                <h1 class="title-item"> {{bolla.nome}} </h1>
            </b-col>
            <b-col>
                <p class="body-item"><small>Data bolla:</small> {{format_date(bolla.data_bolla)}}</p>
                <p class="body-item"><small>Nome del dottore:</small> {{dottore.nome + ' ' + dottore.cognome}}</p>
                <p class="body-item"><small>Nome del paziente:</small> {{paziente.nome + ' ' + paziente.cognome}}</p>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <span v-if="!showBolla">Caricando pdf...</span>
            <iframe v-if="showBolla" :src="bollaUrl+'#view=FitH'" type="application/pdf" width="100%" height="600px" style="overflow: auto; zoom: 1.25;"></iframe>
        </b-row>
    </b-container>
</template>

<script>
import {mixins} from '@/mixins'

export default {
    name: "BollaDetails",
    data (){
        return {
            bollaUrl: null,
            dottore: Object,
            paziente: Object,
            showBolla: false
        }
    },
    props: {
        bolla: Object
    },
    mixins: [mixins],
    created(){
        this.getBolla(this.bolla);
        this.getBollaData(this.bolla)
    },
    methods:{
        getBolla: function(bolla){
            this.$axios
            .get(this.$apibase + '/api/bolle/get_bolla/',
                {
                    responseType: 'arraybuffer',
                    headers:{
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                    params: {
                        bolla: bolla.uid
                    }
                }
            )
            .then((response) => {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                this.bollaUrl = window.URL.createObjectURL(blob);
                this.showBolla = true;
            })
        },
        getBollaData: function(bolla){
            this.$axios
            .get(this.$apibase + '/api/bolle/get_bolla_data/',
                {
                    headers:{
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                    params: {
                        bolla: bolla.uid
                    }
                }
            )
            .then((response) => {
                this.dottore = response.data.dottore;
                this.paziente = response.data.paziente;
            })
        },
        hideModal: function(){
            this.$emit('closeModal');
        }
    }
}
</script>

<style scoped>
    .pdf-container{
        width: 100%;
    }
    .modal-container{
        width: 100% !important;
        max-width: none !important;
        padding: 40px;
        display: inline-block;
    }
    h4, small {
        color: #707070;
    }
    .x-img{
        width: 15px;
    }
    .save-img{
        width: 25px;
    }
    .x-container{
        text-align: right;
        margin-bottom: 20px;
        padding-right: 30px;
        cursor: pointer;
    }
    .title-item{
        margin-bottom: 23px;
    }
    .body-item{
        margin-bottom:8px;
    }
    .first-row{
        margin-bottom: 40px;
    }
    .second-row{
        padding-top: 30px;
    }
</style>